import React from 'react';
import {NavLink} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChartLine, faFilter} from "@fortawesome/free-solid-svg-icons";

const NavItem = (props) => (
    <li>
        <NavLink
            to={props.to}
            className={({isActive}) =>
                `flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                    isActive
                        ? 'bg-pink-600 text-white shadow-sm'
                        : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                }`
            }
        >
            <FontAwesomeIcon icon={props.icon} className="w-4 opacity-80"/>
            <span className="truncate">{props.children}</span>
        </NavLink>
    </li>
);

const TeacherSidebar = (props) => {
    return (
        <nav className="bg-gray-900 h-full w-64 flex-shrink-0 px-3 py-6 overflow-y-auto scrollbar-thin">
            <div className="flex items-center gap-2 mb-8 px-2">
                <div className="h-8 w-8 rounded-lg bg-pink-600 flex items-center justify-center text-white font-bold">P</div>
                <NavLink to='/'>
                    <span className="text-white text-lg font-bold tracking-tight">PegaSoft</span>
                </NavLink>
            </div>
            <div className="mt-6">
                <h3 className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-2 px-2">Live data</h3>
                <ul className="space-y-0.5">
                    <NavItem to='/customer-thematics' icon={faChartLine}>Customer thematic</NavItem>
                </ul>
            </div>
            <div className="mt-6">
                <h3 className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-2 px-2">Live data</h3>
                <ul className="space-y-0.5">
                    <NavItem to='/customer-filters' icon={faFilter}>Customer filters</NavItem>
                </ul>
            </div>
        </nav>
    );
};

export default TeacherSidebar;
